const Months = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

exports.dayCounts = {
  1: 31,
  2: 28,
  3: 31,
  4: 30,
  5: 31,
  6: 30,
  7: 31,
  8: 31,
  9: 30,
  10: 31,
  11: 30,
  12: 31,
};

exports.intMonths = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

const specialSites = [
  "valiant drive",
  "millport, torpoint & woolwich",
  "bathurst street",
  "new michael/melville street",
  "rossett house",
  "coniston & kendal house",
];

exports.isSummer = (siteName = "") => {
  const currentMonth = new Date().getUTCMonth() + 1; // Jan = 0 -> Jan = 1

  const siteMatchFound = specialSites.find((site) => siteName.toLowerCase().includes((site)));

  if (siteMatchFound) {
    return [
      Months.May,
      Months.June,
      Months.July,
      Months.August,
      Months.September,
    ].includes(currentMonth);
  }

  return [
    Months.April,
    Months.May,
    Months.June,
    Months.July,
    Months.August,
    Months.September,
  ].includes(currentMonth);
};
